<template lang="pug">
login-form.login(
  ref='template',
  :loginButtonEvent='loginButtonEvent',
  :moveLinkEvent='moveLinkEvent',
  :errorMessages='errorMessages'
)
  template(#loginTitle) 生徒ログイン
  template(#accountCodeLabel) ID
  template(#passwordLabel) PW
  template(#loginButtonLabel) ログイン
  template(#moveLinkText) 二次元コードでログインする場合はこちら
</template>

<script lang="ts">
import { Component, Mixins, Ref } from 'vue-property-decorator'
import LoginForm from '@/components/templates/student/LoginForm.vue'
import LoginMethods from '@/mixins/LoginMethods'

/**
 * ログイン画面
 */
@Component({
  components: {
    LoginForm,
  },
})
export default class Login extends Mixins(LoginMethods) {
  // テンプレートRef
  @Ref() template!: LoginForm

  // ログインボタン押下時のイベント
  private async loginButtonEvent() {
    this.$loading.start()
    await this.studentLogin(this.template.accountCode, this.template.password)
    this.$loading.complete()
  }

  /**
   * ログイン後の遷移先ページをオーバーライド
   */
  public topPagePath(): string {
    return '/student/study-selection'
  }

  // 遷移リンク押下時のイベント
  private moveLinkEvent() {
    // 二次元コードログインページへ
    this.$router.push({ name: 'StudentQrLogin' })
  }
}
</script>
